import i18 from "../i18n/i18";

export const NavBarLinks = [
    { name: i18.t('NavBar.booksList'), link: '/booksList' },
    { name: i18.t('NavBar.office'), link: '/officesList' }
];

export const NavBarLinksExpert = [
    { name: i18.t('NavBar.booksList'), link: '/booksList' },
    { name: i18.t('NavBar.office'), link: '/officesList' },
    { name: i18.t('NavBar.editDelete'), link: '/editDelete'}
];